// index.tsx

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import '@fontsource-variable/roboto-flex';

// 🚀 AG GRID FIX CRITICO: Importa e Registra i moduli
// ---------------------------------------------------
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';

// Registra il modulo Community una sola volta all'avvio dell'applicazione.
ModuleRegistry.registerModules([AllCommunityModule]);
// ---------------------------------------------------

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(<App />);